import { ProductKinds } from '@components/payments/payment-selection-view'

const PAYMENT_SUCCESS_KIND_ALIASES: Record<string, string> = {
  [ProductKinds.SUBSCRIPTIONS_WITH_BENEFITS_20]: ProductKinds.SUBSCRIPTIONS_WITH_BENEFITS,
  'super-start': ProductKinds.GO_HOLIDAY,
  'product-packages': ProductKinds.ENDLESS_HOLIDAY,
}

export const normalizePaymentSuccessKind = (kind: string | undefined): string | undefined => {
  if (!kind) return undefined

  return PAYMENT_SUCCESS_KIND_ALIASES[kind] ?? kind
}
